import { types } from './configuracaoPixAutomatico.actions'
import { Reducer } from '../../services/reducer.factory'
import storage from '../../services/stoage.service'

const initialState = {
  id: 'configuracaoPixAutomatico',
  booleanFilter: { codigoPsp: [] },
  filterValues: {},
  showHideColumns: [
    {
      label: 'Código',
      value: {
        field: 'oid',
        header: 'Código',
        columnKey: 'oid',
        sortable: true,
        filter: true,
        columnSortField: 'oid',
        visible: true,
      },
    },
    {
      label: 'Nome',
      value: {
        field: 'nome',
        header: 'Nome',
        columnKey: 'nome',
        sortable: true,
        filter: true,
        visible: true,
      },
    },
    {
      label: 'PSP',
      value: {
        field: 'codigoPsp',
        header: 'PSP',
        columnKey: 'codigoPsp',
        columnSortField: 'codigoPsp',
        sortable: true,
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Ambiente',
      value: {
        field: 'ambiente',
        header: 'Ambiente',
        columnKey: 'ambiente',
        sortable: true,
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Jornada Ativa',
      value: {
        field: 'jornadaAtiva',
        header: 'Jornada Ativa',
        columnKey: 'jornadaAtiva',
        sortable: true,
        filter: true,
        visible: true,
      },
    },
  ],
  columnsLookup: [
    {
      field: 'oid',
      header: 'Código',
      columnKey: 'oid',
      sortable: true,
      filter: true,
      columnSortField: 'oid',
      visible: true,
    },
    {
      field: 'nome',
      header: 'Nome',
      columnKey: 'nome',
      sortable: true,
      filter: true,
      visible: true,
    },
  ],
  columns: [],
  currentRecord: {
    oid: '',
    unidade: {},
    nome: '',
    codigoPsp: '',
    ambiente: 'HOMOLOGATION',
    clientId: '',
    clientSecret: '',
    appKey: '',
    certificadoDigital: {},
    jornadaAtiva: 'JORNADA_2',
    recebedorNome: '',
    recebedorCnpj: '',
    recebedorTipoConta: '',
    recebedorAgencia: '',
    recebedorConta: '',
    convenioPix: '',
    politicaRetentativa: 'PERMITE_3R_7D',
    diasExpiracaoSolicitacao: 7,
  },
  messages: null,
  selectedFilters: [],
  usaListDto: false,
  loadingValidarCredenciais: false,
  validacaoCredenciaisResponse: null,
}

const reducer = new Reducer(initialState, types)

export function CRUDConfiguracaoPixAutomaticoReducer(state, action) {
  if (state) {
    state.messages = storage.getAppLabels('configuracaopixautomatico')
  }
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  switch (action.type) {
    case types.RESET:
      return reset(state, action)
    case types.SET_BOOLEAN_FILTER:
      return setBooleanFilter(state, action)
    case types.SET_LOADING_VALIDAR_CREDENCIAIS:
      return { ...state, loadingValidarCredenciais: action.payload }
    case types.SET_VALIDACAO_CREDENCIAIS_RESPONSE:
      return { ...state, validacaoCredenciaisResponse: action.payload }
    default:
      return state
  }
}

function reset(state, action) {
  return { 
    ...state, 
    currentRecord: initialState.currentRecord, 
    records: [], 
    selectedFilters: [],
    loadingValidarCredenciais: false,
    validacaoCredenciaisResponse: null,
  }
}

function setBooleanFilter(state, action) {
  let booleanFilter = Object.assign({}, state.booleanFilter)
  booleanFilter[action.field] = action.value
  return Object.assign({}, state, { booleanFilter })
}
